export default __webpack_public_path__ + "static/media/voiceCloseUp.5c4487c0.png";